export default {
	tenantId: "coverHealth_penTest",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "coverhealth--dev3"
	}
}
